module.exports = __webpack_public_path__ + "img/3.3b19ff8d.png";